import { UiSvgIconSymbolType } from '@/components/ui/SvgIcon';

export const onboardingInterestsOptions: {
  id: UiSvgIconSymbolType;
  title: string;
}[] = [
  {
    id: 'movies',
    title: 'Movies',
  },
  {
    id: 'chatting',
    title: 'Chatting',
  },

  {
    id: 'romantic',
    title: 'Romantic',
  },
  {
    id: 'travel',
    title: 'Travel',
  },
  {
    id: 'sports',
    title: 'Sports',
  },
  {
    id: 'news',
    title: 'News',
  },
  {
    id: 'flirting',
    title: 'Flirting',
  },
  {
    id: 'roleplay',
    title: 'Roleplay',
  },
  {
    id: 'science',
    title: 'Science',
  },
  {
    id: 'animals',
    title: 'Animals',
  },
  {
    id: 'cars',
    title: 'Cars',
  },
  {
    id: 'astrology',
    title: 'Astrology',
  },
  {
    id: 'yoga',
    title: 'Yoga & Meditation',
  },
  {
    id: 'partying',
    title: 'Partying & Clubbing',
  },
  {
    id: 'music',
    title: 'Music',
  },
  {
    id: 'comedy',
    title: 'Comedy',
  },
  {
    id: 'fishing',
    title: 'Fishing',
  },
  {
    id: 'gaming',
    title: 'Gaming',
  },
];
